app.service('propertyService', function ($http) {

  // For PandaDOC -------------------------------------------------

  this.pandadocAPICall = function (obj) {
    return $http.post('/properties/pandadocAPICall', obj)
      .then(function (response) {
        return response
      })
  }

  this.resendDocumentEmail = function (obj) {
    return $http.post('/properties/resendDocumentEmail', obj)
      .then(function (response) {
        return response
      })
  }
  this.sendDocumentsEmail = function (obj) {
    return $http.post('/properties/sendDocumentsEmail', obj)
      .then(function (response) {
        return response
      })
  }
  this.createEsignatureDocument = function (obj) {
    return $http.post('/properties/createEsignatureDocument', obj)
      .then(function (response) {
        return response
      })
  }
  // ----- End For PandaDOC ----------------------------------------


  this.updateTaxCeilings = function (obj) {
    return $http.post('/properties/updateTaxCeilings', obj)
      .then(function (response) {
        return response
      })
  }

  this.getTaxCeilings = function (obj) {
    return $http.post('/properties/getTaxCeilings', obj)
      .then(function (response) {
        return response
      })
  }

  this.updateExemptions = function (obj) {
    return $http.post('/properties/updateExemptions', obj)
      .then(function (response) {
        return response
      })
  }

  this.cancelService = function (obj) {
    return $http.post('/properties/cancelService', obj)
      .then(function (response) {
        return response
      })
  }

  this.updatePropertyValues = function (obj) {
    return $http.post('/properties/updatePropertyValues', obj)
      .then(function (response) {
        return response
      })
  }

  this.updatePropertyCommon = function (obj) {
    return $http.post('/properties/updatePropertyCommon', obj)
      .then(function (response) {
        return response
      })
  }

  this.createHelloSignDocument = function (obj) {
    return $http.post('/properties/createHelloSignDocument', obj)
      .then(function (response) {
        return response
      })
  }

  this.addOutOfBoundsPropertyToAccount = function (obj) {
    return $http.post('/properties/addOutOfBoundsPropertyToAccount', obj)
      .then(function (response) {
        return response
      })
  }

  this.addPropertyToAccount = function (obj) {
    return $http.post('/properties/addPropertyToAccount', obj)
      .then(function (response) {
        return response
      })
  }

  this.processImportedProperties = function (obj) {
    return $http.post('/properties/processImportedProperties', obj)
      .then(function (response) {
        return response
      })
  }

  //-------------------------------------------------


})